import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelector } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.LiberacionEntregaZEDTO;
import { columnas } from "./columns";
const resource = resources.LiberacionEntregaZE;
export class LiberacionEntregaZEList extends React.PureComponent {

    onImprimirAcuses = async (x: Entity) => {
        const data = await resource.ImprimirAcusesInternos(x.IdRegistro);
        await kea.printPdf(data);
    }

    onVer = (x: Entity) => history.go(`./${x.IdRegistro}`);

    items = observeResource(resource.query);
    render() {
        const cols = columnas(this);
        return (
            <div>
                <kea.Title titulo="Liberacion de entregas de zona extendida" />
                <kea.Grid2 columnas={cols} cookieKey={"LiberacionEntregaZEListCookieKey"} items={this.items} />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/liberacionentregasZE/components/list/list.tsx